module.exports = __webpack_public_path__ + "static/media/EGLD.dcf843f1.svg";